export const encodeBoardId = id => "board." + id;
export const decodeBoardId = id => id ? id.split('.') : [];